export default __webpack_public_path__ + "media/images/91-7c9d67f9062357db0beb0bba266719c3.png";